export enum SkeletonLoaderType {
  NONE = "none",
  DEFAULT = "default",
  DEFAULT_TWO_LINES = "default-on-two-lines",
  CIRCLE = "circle",
  TWO_CIRCLES = "two-circles",
  CIRCLE_AND_DEFAULT = "circle-with-text",
  CIRCLE_AND_DEFAULT_TWO_LINES = "circle-with-text-on-two-lines",
}
